import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
interface Person {
  id: string;
  name: string;
  email: string;
  avatar?: string;
  category: string;
  selected: boolean;
}

interface ShareConfirmationData {
  document: any;
  selectedPeople: Person[];
  category: string;
  action?: 'share' | 'unshare'; // Add this to determine the action type
  person?: Person; // For unshare, we might pass a single person
}

@Component({
    selector: 'app-shareconfirmationdialog',
    templateUrl: './shareconfirmationdialog.component.html',
    styleUrls: ['./shareconfirmationdialog.component.css'],
    standalone: false
})
export class ShareconfirmationdialogComponent {
constructor(
    private dialogRef: MatDialogRef<ShareconfirmationdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ShareConfirmationData
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  // For backward compatibility, keep the onShare method
  onShare(): void {
    this.dialogRef.close(true);
  }

  getDocumentName(): string {
    if (this.data.category === 'identity') {
      return this.data.document.name || this.data.document.doctype;
    }
    return this.data.document.name;
  }

  getSelectedPeopleNames(): string {
    // For unshare action with single person
    if (this.data.action === 'unshare' && this.data.person) {
      return this.data.person.name;
    }

    // For share action with multiple people
    if (this.data.selectedPeople.length === 1) {
      return this.data.selectedPeople[0].name;
    } else if (this.data.selectedPeople.length === 2) {
      return `${this.data.selectedPeople[0].name} and ${this.data.selectedPeople[1].name}`;
    } else {
      return `${this.data.selectedPeople[0].name} and ${this.data.selectedPeople.length - 1} others`;
    }
  }

  isUnshareAction(): boolean {
    return this.data.action === 'unshare';
  }

  isShareAction(): boolean {
    return !this.data.action || this.data.action === 'share';
  }

  getActionTitle(): string {
    return this.isUnshareAction() ? 'Unshare' : 'share';
  }

  getActionPreposition(): string {
    return this.isUnshareAction() ? 'with' : 'with';
  }

  getConfirmButtonText(): string {
    return this.isUnshareAction() ? 'Unshare' : 'Share';
  }

  getConfirmButtonColor(): string {
    return this.isUnshareAction() ? 'warn' : 'primary';
  }
}